import React from "react";

const DandruffTreatmentBook = () => {
  return (
    <div className="hairSubServiceHead">
      <h3>Book Your Dandruff Treatment Today</h3>
      <p>
        Don’t let dandruff affect your confidence and comfort any longer.
        <a href="https://scentlifestyle.com/">SCENT’s dandruff treatment in Bangalore</a> offers effective,
        sustainable solutions tailored to your unique needs. Our team of experts
        is dedicated to helping you achieve a healthy, flake-free scalp.
      </p>
      <p>
        Contact us today to schedule your consultation and take the first step
        towards healthier scalp and hair. At SCENT, we’re here to make you look
        and feel your best, every day.
      </p>
      <br />
    </div>
  );
};

export default DandruffTreatmentBook;
